import type { SelectHTMLAttributes, ReactNode } from 'react';

interface Props extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  hint?: ReactNode;
  error?: string | null;
}

export function Select({ label, hint, error, id, className, children, ...rest }: Props): React.ReactElement {
  const selectId = id ?? rest.name;
  return (
    <label htmlFor={selectId} className="block">
      {label && <span className="mb-1 block text-sm font-medium text-[var(--color-header)]">{label}</span>}
      <select
        id={selectId}
        {...rest}
        className={[
          'block w-full rounded-[var(--radius-button)] border border-[var(--color-border)] bg-white px-3 py-2.5 text-[15px] text-[var(--color-body)] outline-none transition focus:border-[var(--color-t3-blue)] focus:ring-2 focus:ring-[var(--color-t3-blue)]/30',
          className ?? '',
        ].join(' ')}
      >
        {children}
      </select>
      {hint && !error && <span className="mt-1 block text-xs text-[var(--color-muted)]">{hint}</span>}
      {error && <span className="mt-1 block text-xs text-[var(--color-danger)]">{error}</span>}
    </label>
  );
}
